import { render, staticRenderFns } from "./PutDrugBatch.vue?vue&type=template&id=195a9be4&scoped=true&lang=pug&"
import script from "./PutDrugBatch.vue?vue&type=script&lang=ts&"
export * from "./PutDrugBatch.vue?vue&type=script&lang=ts&"
import style0 from "./PutDrugBatch.vue?vue&type=style&index=0&id=195a9be4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195a9be4",
  null
  
)

export default component.exports